import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ProjectOutlined,
  ScheduleOutlined,
  FileTextOutlined,
  BarChartOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ProjectOutlined />,
  1: <ScheduleOutlined />,
  2: <FileTextOutlined />,
  3: <BarChartOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("pm");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-pm-section dev-pm-highlights-section">
      <div className="dev-pm-section-inner">
        <h2 className="dev-section-h2 dev-pm-section-h2">
          <span className="dev-pm-section-h2-icon dev-pm-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-pm-highlights-grid">
          <div className="dev-pm-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-pm-highlight-item">
                <div className="dev-pm-highlight-icon">
                  {iconByIndex[idx] ?? <ProjectOutlined />}
                </div>
                <div>
                  <div className="dev-pm-highlight-title">{item.title}</div>
                  <div className="dev-pm-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-pm-stat-card dev-pm-stat-card--ontime">
            <div className="dev-pm-stat-value">{statValue}</div>
            <div className="dev-pm-stat-label">{statLabel}</div>
            <div className="dev-pm-stat-desc">{statDesc}</div>
            <div className="dev-pm-stat-badge">{t("highlights.stat_badge")}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
